// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ev-3";
export var flatBottomCorners = "_ev-5";
export var productImage = "_ev-0";
export var quantityContainer = "_ev-2";
export var quantityHeader = "_ev-6";
export var tooltip = "_ev-1";
export var wrapAndEllipsesOverflow = "_ev-4";